import React, { Dispatch, Fragment, SetStateAction, useState } from "react";
import { Link, navigate } from "gatsby";

import { DropdownMenuItemTypes } from "../../../../types/layout";
import { menuItems } from "../../../../constants/enums";
import ICONS from "../../../../constants/icons";

import Icon from "../../../icon/Icon";

const MenuItems = ({
  setOpen,
}: {
  setOpen?: Dispatch<SetStateAction<boolean>>;
}) => {
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const handleClickMenuItem = (
    dropdown: DropdownMenuItemTypes[] | undefined,
    path: string,
    id: string
  ) => {
    setActiveItem(activeItem === String(id) ? null : String(id));

    if (!dropdown) {
      setOpen && setOpen(false);

      navigate(path);
    }
  };

  return (
    <Fragment>
      {menuItems.map(({ id, name, dropdown, path, rounded }) => (
        <div
          key={id}
          className={`-menu -menuItem m-navbar__menuItem aligned-center -column-gap10 ${
            dropdown ? "-withDropdown" : ""
          } ${rounded ? "-rounded" : ""} ${
            activeItem === String(id) ? "-active" : ""
          }`}
          onClick={() => handleClickMenuItem(dropdown, path, id)}
        >
          <div
            className={`aligned-center -column-gap10 ${
              dropdown ? "-dropdownLink" : ""
            }`}
          >
            {name}
            {dropdown && <Icon name={ICONS.ARROW_DOWN} />}
          </div>
          {dropdown && (
            <div className={`-dropdownMenu column`}>
              {dropdown.map(({ id, name, path }) => {
                return (
                  <Link to={path} key={id} className="-dropdownItem -whiteText">
                    <span>{name}</span>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </Fragment>
  );
};

export default MenuItems;
